const acDomain = 'https://140212.origintheatrical.com.au'
export default acDomain
